varying vec3 vPositionW;
varying vec3 vNormalW;
varying vec2 vUv;
uniform vec3 uCarrierPosition;
varying float vCarrierDistance;

void main() {
  // vPositionW  = (modelMatrix * vec4(position, 1.0)).xyz;
  // vNormalW = normalize( mat3( modelMatrix[0].xyz, modelMatrix[1].xyz, modelMatrix[2].xyz ) * normal );
  vUv = uv;
  vCarrierDistance = distance((modelMatrix * vec4(position, 1.0)).xyz, uCarrierPosition);

  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}